import { render, staticRenderFns } from "./WarningInformation.vue?vue&type=template&id=34ccd7bd&scoped=true"
import script from "./WarningInformation.vue?vue&type=script&lang=js"
export * from "./WarningInformation.vue?vue&type=script&lang=js"
import style0 from "./WarningInformation.vue?vue&type=style&index=0&id=34ccd7bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ccd7bd",
  null
  
)

export default component.exports